import AnamnesiBotoxList from "./pages/AnamnesiBotoxList.vue"
import AnamnesiBotoxEdit from "./pages/AnamnesiBotoxEdit.vue"
import AnamnesiBotoxView from "./pages/AnamnesiBotoxView.vue"


export default {
    AnamnesiBotoxList,
    AnamnesiBotoxEdit,
    AnamnesiBotoxView,
  };